export var DatePickerStyles = function (props) {
    var theme = props.theme;
    var effects = theme.effects;
    return {
        callout: {
            border: 'none',
            borderRadius: effects.roundedCorner2,
            boxShadow: effects.elevation8,
            selectors: {
                '.ms-Callout-main': { borderRadius: effects.roundedCorner2 },
            },
        },
    };
};
//# sourceMappingURL=DatePicker.styles.js.map